import PropTypes from "prop-types";
import React from "react";
import FormText from "react-bootstrap/FormText";

function FlatButton(props) {
  const {
    buttonProps,
    className,
    disabled,
    helpText,
    iconClass,
    title,
    onClick,
  } = props;

  return (
    <div className={"flat-button " + className}>
      <button
        className="btn btn-default"
        {...buttonProps}
        disabled={disabled}
        onClick={onClick}
      >
        <span className="fa-stack fa-2x">
          <i className={"fa fa-stack-2x " + iconClass} aria-hidden="true" />
        </span>
        <span className="button-text">{title}</span>
        <br />
      </button>
      {helpText && <FormText>{helpText}</FormText>}
    </div>
  );
}

FlatButton.propTypes = {
  buttonProps: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  helpText: PropTypes.string,
  iconClass: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
};

FlatButton.defaultProps = {
  buttonProps: {},
  className: "",
  onClick: () => {},
};

export { FlatButton };
